import styled from 'styled-components';

const FieldSlideOutSection = styled.div`
  margin-bottom: 16px;
`;

export default FieldSlideOutSection;
